import {getUniRouteConfig, abTestApi} from "@/pages/Campaign/api";
import {envType} from "@/pages/Campaign/utils/common";
import {ENV_TYPE} from "@/pages/Campaign/utils/enum";
import _ from "lodash";
import h5plus from "@mainto/h5plus";
// eslint-disable-next-line
import { h5plusReday } from '@mainto/h5plus'

const TABBAR_PAGE_ROUTE = [
  'pages/index/index',
  'pages/allProduct/index',
  'pages/store/index',
  'pages/order/index',
  'pages/profile/index'
]

export const BRAND = {
  HIMO: 'himo',
  FAMILY: 'family',
  MAN_TU: 'man_tu',
  TIAN_SHENG: 'tian_sheng',
  HIMORE: 'himore'
}

export const WX_APP_ID = {
  HIMO: 'wx1f789867a86f5c82',
  FAMLILY: 'wx7187da6dfcd619c9',
  MAN_TU: 'wx295fb795503abb3c',
  HIMORE: 'wx8e54834d41fcc796',
  TIAN_SHENG: 'wx102b6eea7578bc6b',
}

function parseBrand() {
  const queries = window.location.href.split('?')?.[1]
  if (!queries) return BRAND.HIMO
  const queryArr = queries.split('&')
  for (let query of queryArr) {
    if (query.includes('campaignBrand')
      // 兼容 brand 参数
      || query.includes('brand')) {
      const split = query.split('=')
      return split?.[1]
    }
  }

  return BRAND.HIMO
}

let env = envType()
const currentBrand = parseBrand()

// app h5plus初始化
let $h5plus = h5plus
h5plusReday().then((res) => {
  $h5plus = res
  const isInApp = res.isInApp()
  if (isInApp) {
    env = ENV_TYPE.APP
  }
})

function getWxMiniId(brand) {
  switch (brand) {
  case BRAND.HIMO:
    return WX_APP_ID.HIMO
  case BRAND.FAMILY:
    return WX_APP_ID.FAMLILY
  case BRAND.MAN_TU:
    return WX_APP_ID.MAN_TU
  case BRAND.HIMORE:
    return WX_APP_ID.HIMORE
  case BRAND.TIAN_SHENG:
    return WX_APP_ID.TIAN_SHENG
  default:
    return null
  }
}

class UniRoute {
  #routes = []

  async getUniRouteConfig() {
    const result = await getUniRouteConfig()
    if (result) this.#routes = result
  }

  route({ scene, brand, arg }, cb) {
    if (!scene || !brand) return
    switch (scene) {
    case 'activity-h5':
      this._routeActivity(arg, cb)
      break
    default:
      this._routeDefault(scene, brand, arg, cb)
    }
  }

  // 悬浮按钮跳转逻辑处理
  floatButtonRoute({jumpLinkType, wxMiniId, jumpLink}) {
    this._routeActivity({
      linkType: jumpLinkType,
      linkUrl: jumpLink,
      wxMiniId: wxMiniId
    })
  }

  // 活动跳转逻辑处理
  _routeActivity(arg, cb) {
    if (arg.linkType === 'h5') {
      cb && cb(arg.linkUrl)
      this._jump(ENV_TYPE.H5, arg.linkUrl)
    } else if (arg.linkType === 'mp') {
      // 如果没有指定微信小程序 id，直接跳转当前小程序
      if (!arg.wxMiniId) {
        cb && cb(arg.linkUrl)
        this._jump(env, arg.linkUrl)
        return
      }

      // 只有微信小程序可以跳转
      if (!(env === ENV_TYPE.WX_MP)) return

      const isSameWxMini = arg.wxMiniId && (arg.wxMiniId === getWxMiniId(currentBrand))

      // 如果为当前小程序 id,直接跳转
      if (isSameWxMini) {
        cb && cb(arg.linkUrl)
        this._jump(env, arg.linkUrl)
      } else {
        // 否则跳转中转页
        const jumpPath = this._getJumpPath()
        const path = `/${jumpPath}?appId=${arg.wxMiniId}&miniPath=${encodeURIComponent(arg.linkUrl)}`
        cb && cb(path)
        this._jump(env, path)
      }
    }
  }

  async _routeDefault(scene, brand, arg, cb) {
    let routeConfig = await this._getRouteUrl(scene, brand, arg)
    let path = routeConfig?.path
    if (!path) return
    if (arg) path = this._formatArg(path, arg)

    console.log('------env _routeDefault------', env)

    if (brand === currentBrand) {
      let jumpEnv = routeConfig.isH5 ? ENV_TYPE.H5 : env
      // h5 或者 App 不加斜杠
      path = (routeConfig.isH5 || env === ENV_TYPE.APP) ? path : `/${path}`
      cb && cb(path)
      this._jump(jumpEnv, path)
    } else if (routeConfig.outMini) {
      const jumpPath = this._getJumpPath()

      if (!jumpPath) return
      const data = encodeURIComponent(path)
      path = `/${jumpPath}?appId=${getWxMiniId(brand)}&miniPath=${data}`
      cb && cb(path)
      this._jump(env, path)
    }
  }

  _jump(env, path) {
    if (!path) return
    const isTabBar = this._isTabBarPage(path)
    let url = path
    if (isTabBar) {
      url = path.split('?')[0]
    } else if (!_.isEmpty(this.$route) && !_.isEmpty(this.$route.query)) {
      const { x_stream_id } = this.$route.query
      url = path.indexOf('?') > -1 ? `${path}&x_stream_id=${x_stream_id}` : `${path}?x_stream_id=${x_stream_id}`
    }

    const jumpMethod = isTabBar ? 'switchTab' : 'navigateTo'
    switch (env) {
    case ENV_TYPE.WX_MP:
      let wxMini = window.wx.miniProgram;
      // 测试发现，miniProgram时有时没有？ 到底是window.wx 还是window.wx.miniProgram
      if (_.isEmpty(wxMini)) {
        window.wx[jumpMethod]({ url });
      }

      window.wx.miniProgram[jumpMethod]({ url })
      break
    case ENV_TYPE.TT_MP:
      window.tt.miniProgram[jumpMethod]({ url })
      break
    case ENV_TYPE.ALI_MP:
      window.my[jumpMethod]({ url })
      break
    case ENV_TYPE.XHS_MP:
      xhs.miniProgram[jumpMethod]({ url })
      break
    case ENV_TYPE.APP:
      if (url.startsWith('http')) {
        window.$location.href = url
      } else {
        $h5plus.navigate({ path: url })
      }
      break
    case ENV_TYPE.H5:
      window.location = url
      break
    default:
      break
    }
  }

  _isTabBarPage(url) {
    if (!url) return false
    return TABBAR_PAGE_ROUTE.some(tabPath => url.includes(tabPath))
  }

  async _getRouteUrl(scene, brand, arg) {
    if (!scene || !brand) return null
    const sceneConfig = this.#routes.find(e => e.scene === scene)
    if (!sceneConfig) return null

    const route = sceneConfig?.routes.find(e => e.brand === brand)
    if (!route) return null
    let path = route.path?.[env]
    const h5Path = route.path?.['h5']
    const isH5 = env === ENV_TYPE.H5
    const outMini = currentBrand !== brand

    // 家庭产品使用ab接口
    if (brand === BRAND.FAMILY) {
      const productId = arg.productId
      const res = await abTestApi({
        featureName: 'abCategoryId',
        mixIds: [productId]
      })

      const enableIds = res.enableIds || []
      if (enableIds.includes(productId)) {
        path = 'familyReserve/pages/newProductDetail/index?id=${productId}'
      }
    }
    if (outMini && path) {
      return {
        path: path,
        isH5: true,
        outMini: true
      }
    } else {
      return {
        path: path || h5Path,
        isH5: isH5,
        outMini: outMini
      }
    }
  }

  _getJumpPath() {
    const sceneConfig = this.#routes.find(e => e.scene === 'jump')
    if (!sceneConfig) return null

    const route = sceneConfig?.routes.find(e => e.brand === currentBrand)
    if (!route) return null

    return route.path?.[env]
  }

  _formatArg(path, arg) {
    if (!path) return null
    if (!arg) return path

    let result = path
    for (let [k, v] of Object.entries(arg)) {
      const regex = new RegExp(`\\$\\{${k}}`, 'g')
      result = result.replace(regex, v)
    }

    // 去除多余参数
    const regex = new RegExp(`\\$\\{.+}`, 'g')
    result = result.replace(regex, 'null')

    return result
  }
}


export const UNI_ROUTE = new UniRoute()
